import { Status } from "../../DataFrame";
import { IDIService } from "../../IDIService";
import { ResponseResult } from "../FieldChangeResult";

export interface IGeolocationService extends IDIService {
	GetCurrentGeolocationAsync(): Promise<GeolocationPosition | GeolocationPositionError>;
	SetControllerGeolocationAsync(location: Coordinates | Status): Promise<ResponseResult<SetGeolocationResponseCode>>;
	GetControlllerGeolocationAsync(): Promise<CoordinatesWithSourceInfo | Status>;
	IsControllerGeolocationSetAsync(): Promise<boolean | Status>;
}

export class Coordinates {
	Longitude: number = 0;
	Latitude: number = 0;
}

export class CoordinatesWithSourceInfo {
	Longitude: number = 0;
	Latitude: number = 0;
	IsNetworkBased: boolean = false;
}

export enum SetGeolocationResponseCode {
	OK = 0,
	NoPermissions = 1,
	UserIsNotLoggedIn = 2,
	UnknownError = 3,
}